import React, { useContext, useEffect, useRef } from 'react'
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";
import {
    UiButton,
} from "../../../_uiComponents/common/form/UiButton";
import Alert from '@mui/material/Alert';
import { useDispatch } from 'react-redux';
import { contextApiActions } from '../../../../_redux/_constants';
import { dataTemplateAddTableRecordRequest, dataTemplateGetJsonSchemaRequest } from '../../../../_redux/_actions';
import { useSelector } from 'react-redux';
import { Context } from '../../../../_context/Store';

export default function AddRecordDataModal(props) {

    const stringRef = useRef("");

    const actionDispatch = useDispatch();
    const [state, dispatch] = useContext(Context);


    useEffect(() => {
        actionDispatch(
            dataTemplateGetJsonSchemaRequest({ id: props.Id }),
        );
   }, []);

   const { manageList } = useSelector((state) => {
    return {
         manageList: state.dataTemplate.dataSchema,
    };
    });


    const closeModal = () => {
     dispatch({
          type: contextApiActions.UI_MODAL_TOGGEL,
          payload: {
               show: false,
          },
     });
};

    const addDataRecord = () => {
        actionDispatch(
            dataTemplateAddTableRecordRequest({
                  dataTemplateId: props.Id,
                  jsonObjectString: stringRef.current,
                  getManageDataList: props.getManageDataList,
                  closeModal,
             },
          ),
        );
   };



    return (
        <>
        <div className="sba-add-record-data-wr">
             <div className="sba-upload-json-view">
                  <JsonView
                       src={manageList}
                       editable={{
                            delete: false,
                            edit: true,
                       }}
                       onEdit={(params) => {
                            stringRef.current = JSON.stringify(
                                 params.src,
                            );
                       }}
                  />
             </div>
             <div className="sba-add-record-data-wr__save">
                  <UiButton
                       onClick={addDataRecord}
                       name="Save"
                       variant="contained"
                  />
             </div>
        </div>
   </>
    )
}
